import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Assessments from './pages/Assessments';
import AssessmentDetail from './pages/AssessmentDetail';
import Dashboard from './pages/Dashboard';
import ReportView from './pages/ReportView';
import ComparisonTool from './pages/ComparisonTool';
import RecommendationsHub from './pages/RecommendationsHub';
import CustomReportBuilder from './pages/CustomReportBuilder';
import TeamManagement from './pages/TeamManagement';
import AssessmentHistory from './pages/AssessmentHistory';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <div className="no-print">
          <Header />
        </div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/assessments" element={<Assessments />} />
          <Route path="/assessment/:id" element={<AssessmentDetail />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/report/:id" element={<ReportView />} />
          <Route path="/report/:id/customize" element={<CustomReportBuilder />} />
          <Route path="/compare" element={<ComparisonTool />} />
          <Route path="/recommendations" element={<RecommendationsHub />} />
          <Route path="/team" element={<TeamManagement />} />
          <Route path="/history/:title" element={<AssessmentHistory />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;